module.exports = __webpack_public_path__ + "pps_slide_mobile.webp";